import { ChangeEvent, PanelStyles, Tree, TreeProps } from "@mcleod/components";
import { ArrayUtil } from "@mcleod/core";
import { MainMenu } from "./MainMenu";
import { MenuTreeNode } from "./MenuTreeNode";
import { MenuTreeNodeLeaf } from "./MenuTreeNodeLeaf";


export class MainMenuTree extends Tree<MenuTreeNode> {
    private mainMenu: MainMenu;
    constructor(mainMenu: MainMenu, props?: Partial<TreeProps>) {
        super({
            fillRow: true,
            borderWidth: 0,
            selectedNodeBackgroundColor: "component.palette.hover.backgroundColor",
            selectedNodeColor: (node) => node.color,
            ...props
        });

        this.setClassIncluded(PanelStyles.slimScrollbar);
        this.mainMenu = mainMenu;
        this.addChangeListener(this.onChange);
        this.addFocusListener(this.onFocusGained);
        this.addBlurListener(() => this.selectedNode = null);
    }

    private onFocusGained = () => {
        if (this.selectedNode == null && this.getRootNode().getChildCount() > 0) {
            this.getRootNode().selectFirstChild();
        }
    }

    private onChange = (event: ChangeEvent) => {
        const changedNodes = [
            ...ArrayUtil.getAsArray(event.newValue),
            ...ArrayUtil.getAsArray(event.oldValue)
        ];
        changedNodes.forEach(node => {
            if (node instanceof MenuTreeNodeLeaf) {
                node.doOnSelectionChanged();
            }
        });

        if (this.selectedNode != null && this.mainMenu != null) {
            const { treeMenu, treeFavoritesMenu, textSearchMenu } = this.mainMenu;

            const otherTree = treeMenu === this ? treeFavoritesMenu : treeMenu;
            if (otherTree != null) {
                otherTree.selectedNode = null;
                otherTree._element.blur();
            }
            if (!textSearchMenu.hasFocus()) {
                this.focus();
            }
            if (event.userInitiatedChange !== true) {
                requestAnimationFrame(() => this.scrollToSelection());
            }
        }
    }

    isLastMountedNodeSelected(): boolean {
        if (this.selectedNode == null) {
            return false;
        }
        return this.selectedNode === ArrayUtil.getLastElement(this.getMountedNodes());
    }

    selectLastMountedNode() {
        this.selectedNode = ArrayUtil.getLastElement(this.getMountedNodes());
    }
}
